/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card image instance
 *
 * @module enervee_utils.product_card
 */
function productCardImageDirective() {
    return {
        restrict: 'E',
        // this one is needed here. otherwise, images don't show up. need to debug that. - brie 3/27
        replace: true,
        scope: {
            product: '='
        },
        template: require('./imageView.html')
    };
}

module.exports = productCardImageDirective;
